/**
 * Public host URLs for Cloud Run prod vs dev (*-dev.serviceflow-pro.com).
 * Keep in sync with scripts/deploy-scripts/deploy-env.sh
 */
export const CLOUD_PROD_HOSTS = {
  api: 'https://api.serviceflow-pro.com',
  /** Public ServiceFlow marketing site */
  web: 'https://serviceflow-pro.com',
  /** Authenticated SPA */
  webApp: 'https://app.serviceflow-pro.com',
  /** Garage Door OS marketing site */
  garage: 'https://garagedooros.com',
  /** Garage Door OS authenticated SPA */
  garageApp: 'https://app.garagedooros.com',
  customer: 'https://customer.serviceflow-pro.com',
  callServiceApi: 'https://call-service-api.serviceflow-pro.com',
  callCenter: 'https://call-service.serviceflow-pro.com',
  messenger: 'https://messenger.serviceflow-pro.com',
  widgets: 'https://widgets.serviceflow-pro.com',
  mcp: 'https://mcp.serviceflow-pro.com',
  visualizerApi: 'https://visualizer-api.serviceflow-pro.com',
  visualizerFrontend: 'https://visualizer.serviceflow-pro.com',
  gmailPortal: 'https://gmail.serviceflow-pro.com',
  marketingApi: 'https://marketing-api.serviceflow-pro.com',
  marketingPortal: 'https://marketing.serviceflow-pro.com',
  /** Standalone Content Autopilot marketing domain (also maps content.serviceflow-pro.com). */
  contentPortal: 'https://content-autopilot.com',
  contentApi: 'https://content-api.serviceflow-pro.com',
  outreachApi: 'https://outreach-api.serviceflow-pro.com',
  /** Authenticated RangeLeads product app */
  outreachPortal: 'https://app.rangeleads.com',
  /** Public RangeLeads marketing (SSR) */
  rangeleadsWeb: 'https://rangeleads.com',
} as const

export const CLOUD_DEV_HOSTS = {
  /** Shared with prod until serviceflow-api-dev exists */
  api: 'https://api.serviceflow-pro.com',
  web: 'https://dev.serviceflow-pro.com',
  webApp: 'https://dev-app.serviceflow-pro.com',
  garage: 'https://garagedooros.com',
  garageApp: 'https://app.garagedooros.com',
  customer: 'https://customer.serviceflow-pro.com',
  callServiceApi: 'https://call-service-api.serviceflow-pro.com',
  callCenter: 'https://call-service.serviceflow-pro.com',
  messenger: 'https://messenger.serviceflow-pro.com',
  widgets: 'https://widgets.serviceflow-pro.com',
  mcp: 'https://dev-mcp.serviceflow-pro.com',
  visualizerApi: 'https://visualizer-api.serviceflow-pro.com',
  visualizerFrontend: 'https://visualizer.serviceflow-pro.com',
  gmailPortal: 'https://gmail.serviceflow-pro.com',
  marketingApi: 'https://dev-marketing-api.serviceflow-pro.com',
  marketingPortal: 'https://dev-marketing.serviceflow-pro.com',
  contentPortal: 'https://dev-content.serviceflow-pro.com',
  contentApi: 'https://dev-content-api.serviceflow-pro.com',
  outreachApi: 'https://outreach-api.serviceflow-pro.com',
  outreachPortal: 'https://app.rangeleads.com',
  rangeleadsWeb: 'https://rangeleads.com',
} as const

type ViteDeployEnv = {
  PROD?: boolean
  VITE_DEPLOY_ENV?: string
}

function viteDeployEnv(): ViteDeployEnv {
  const meta = import.meta as ImportMeta & { env?: ViteDeployEnv }
  return meta.env ?? {}
}

/** Vite production build targeting dev Cloud Run (DEPLOY_ENV=dev). */
export function isCloudDevDeploy(): boolean {
  const env = viteDeployEnv()
  return env.PROD === true && env.VITE_DEPLOY_ENV === 'dev'
}

export function cloudApiHosts(): typeof CLOUD_PROD_HOSTS | typeof CLOUD_DEV_HOSTS {
  return isCloudDevDeploy() ? CLOUD_DEV_HOSTS : CLOUD_PROD_HOSTS
}
